<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="title"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <p class="col-12 q-ma-none">
        {{ message }}
        (<strong>{{ target }}</strong>)
      </p>
      <hr-text-field
        v-model="inputValue"
        :label="$t('common.inputStrictConfirmLabel', { target })"
        :rules="[(val) => !val || val === target || inputWarning]"
        lazy-rules
        autofocus
        clearable
        hide-bottom-space
        class="col-12"
        data-e2e="input-strict-confirm"
      />
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-destructive-btn
        :label="okLabel"
        :disable="!isCompletedRight"
        data-e2e="button-strict-confirm"
        @click="onOkClick"
      />
    </template>
  </hr-form-dialog>
</template>

<script>
import {
  HrDestructiveBtn,
  HrDismissBtn,
  HrFormDialog,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'StrictConfirmDialog',

  components: {
    HrDestructiveBtn,
    HrDismissBtn,
    HrFormDialog,
    HrTextField,
  },

  props: {

    title: {
      type: String,
      required: true,
    },

    /**
     * Value user should complete input with to be able to confirm the dialog
     */
    target: {
      type: String,
      required: true,
    },

    message: {
      type: String,
      required: true,
    },

    inputWarning: {
      type: String,
      default: '',
    },

    okLabel: {
      type: String,
      required: true,
    },

  },

  emits: ['hide', 'ok'],

  data() {
    return {
      inputValue: '',
    };
  },

  computed: {
    isCompletedRight() {
      return this.inputValue === this.target;
    }, // isCompletedRight()

  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    }, // show()

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    }, // onDialogHide()

    async onOkClick() {
      this.$emit('ok');
      this.hide();
    }, // onOkClick()
  },

};
</script>
